export default __webpack_public_path__ + "static/media/profile__avatar.a2dd1e84.png";